<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-12 sp-0">
        <ng-container *ngIf="tabletSize.matches">
            <tt-page-heading
                *ngIf="p2ReleaseNoteKeyno === '0'"
                ttModel="h_release_note_new"
                ttTranslate>
            </tt-page-heading>
            <tt-page-heading
                *ngIf="p2ReleaseNoteKeyno !== '0'"
                ttModel="h_release_note_edit"
                ttTranslate>
            </tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
        </ng-container>

        <tt-datetime
            ttLabel="reg_datetime"
            [ttModel]="edit.reg_datetime"
            ttMinutePrecision="1"
            ttReadonly>
        </tt-datetime>
        <tt-textarea ttLabel="description" [(ttModel)]="edit.public_note"></tt-textarea>
        <tt-input
            *ngIf="!!edit.video_url"
            ttLabel="video_url"
            [ttModel]="edit.video_url"
            [ttButtons]="videoUrlButtons"
            ttReadonly>
        </tt-input>
        <tt-select
            *ngIf="edit.show === '0'"
            ttLabel="releasetype"
            [ttModel]="edit.releasetype"
            [ttData]="releaseTypes"
            ttDataId="releasetype"
            ttDataName="releasetype_name"
            ttReadonly>
        </tt-select>

        <ng-container *ngIf="edit.show === '1'">
            <tt-textarea ttLabel="internal_note" [(ttModel)]="edit.internal_note"></tt-textarea>
            <tt-input ttLabel="portal_user_name" [ttModel]="edit.portal_user_name" ttReadonly></tt-input>
            <tt-select
                ttLabel="releasetype"
                [(ttModel)]="edit.releasetype"
                [ttData]="releaseTypes"
                ttDataId="releasetype"
                ttDataName="releasetype_name">
            </tt-select>
            <tt-button-save [ttLocked]="lockedSave" (ttClick)="saveChanges()"></tt-button-save>
        </ng-container>
    </tt-card>
</tt-page>
